export const FETCH_SKILLS_REQUEST = 'FETCH_SKILLS_REQUEST';
export const FETCH_SKILLS_SUCCESS = 'FETCH_SKILLS_SUCCESS';
export const FETCH_SKILLS_FAILED = 'FETCH_SKILLS_FAILED';
export const SELECTED_SKILL = 'SELECTED_SKILL';
export const RESET_SELECTED_SKILL = 'RESET_SELECTED_SKILL';
